export default "__VITE_ASSET__c2548c12__"